import { ReactNode } from 'react';
import { Title } from '@mantine/core';

// Shared layout for the sections on the customer Details tab ("Customer details", which
// includes the primary contact and addresses, and "Additional details"). Every section uses the same grid so
// fields line up in columns across sections: 3 columns on desktop, 2 on tablets, 1 on phones.
export const DETAILS_GRID_PROPS = {
  cols: { base: 1, sm: 2, md: 3 },
  spacing: 20,
  verticalSpacing: 0,
} as const;

export function DetailsSectionTitle({ children, first = false }: { children: ReactNode; first?: boolean }) {
  return (
    <Title order={5} fz={16} fw={600} c="gray.9" mt={first ? 0 : 40} mb={4}>
      {children}
    </Title>
  );
}
